import React from "react";
import { AppContextType } from "../../../AppContext";
import { soundSingleChord } from "../../../functions/playNotesAudio";
import { ChordHistoryInteractMode } from "../../../models/ChordHistoryOptions.model";
import { ChordInScaleEdit, toShortChordName } from "../../../models/wasm.model";
import "./MusicChord.css";

interface Props {
  chord: ChordInScaleEdit;
  /** The chord which best matches the audio is first.  It's the one sounded on replay.  Make it more visible. */
  isMostLikely: boolean;
  onDelete?: () => void;
  onExpand?: ({ x, y }: { x: number; y: number }) => void;
  onChooseForInstrumentation?: () => void;
}

interface State {}

export default class MusicChord extends React.Component<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  handleChordClick = (e: React.MouseEvent<any>) => {
    e.preventDefault();
    if (this.context.chordHistoryOptions.interactMode === ChordHistoryInteractMode.SOUND) {
      const arpeggiate = this.context.chordHistoryOptions.sounding.arpeggiation;
      const bassNoteId = this.props.chord.bass_note_id;
      soundSingleChord(this.props.chord.notes, { arpeggiate, bassNoteId });
    } else if (this.context.chordHistoryOptions.interactMode === ChordHistoryInteractMode.EDIT) {
      this.props.onExpand?.({ x: e.pageX, y: e.pageY });
    } else if (this.context.chordHistoryOptions.interactMode === ChordHistoryInteractMode.DELETE) {
      this.props.onDelete?.();
    } else if (this.context.chordHistoryOptions.interactMode === ChordHistoryInteractMode.CHOOSE) {
      this.props.onChooseForInstrumentation?.();
    }
  };

  render() {
    const { chord, isMostLikely } = this.props;
    const labelMode = this.context.chordHistoryOptions.labelMode;
    const isScaleMajor = this.context.keySelectionOptions.isPreferMajor;
    const isBestCss = isMostLikely ? "most-likely-chord" : "";
    const classes = `music-chord-header ${isBestCss}`;
    return (
      <span className={classes} onClick={this.handleChordClick}>
        {toShortChordName(chord, { labelMode, isScaleMajor })}
      </span>
    );
  }
}

MusicChord.contextType = AppContextType;
